<div class="mission-performance-container">
  <app-analytics-card [title]="'ANALYTICS.TREND_SMART_ENERGY' | translate">
    <div class="chart-header">
      <div class="chart-controls">
        <div
          class="chart-dataset-toggle kwh-minus"
          [class.hidden]="!isKWHMinusVisible()"
          role="button"
          (click)="toggleKWHMinusDataset()"
          (keydown.enter)="toggleKWHMinusDataset()"
          tabindex="0"
        >
          <div class="color"></div>
          <span>{{ 'ANALYTICS.SMART_ENERGY_KWH_MINUS' | translate }}</span>
        </div>

        <div
          class="chart-dataset-toggle kwh-plus"
          [class.hidden]="!isKWHPlusVisible()"
          role="button"
          (click)="toggleKWHPlusDataset()"
          (keydown.enter)="toggleKWHPlusDataset()"
          tabindex="0"
        >
          <div class="color"></div>
          <span>{{ 'ANALYTICS.SMART_ENERGY_KWH_PLUS' | translate }}</span>
        </div>
      </div>

      <div class="chart-group-select">
        <label for="group-select">{{ 'ANALYTICS.GROUP_BY' | translate }}</label>
        <select id="group-select" #groupSelect (change)="onGroupChange(groupSelect.value)">
          <option value="year" [selected]="selectedGroup === 'year'">{{ 'ANALYTICS.YEAR' | translate }}</option>
          <option value="month" [selected]="selectedGroup === 'month'">{{ 'ANALYTICS.MONTH' | translate }}</option>
          <option value="day" [selected]="selectedGroup === 'day'">{{ 'ANALYTICS.DAY' | translate }}</option>
        </select>
      </div>
    </div>

    <app-analytics-widget [query]="'smart-energy-grouped'" [filters]="filters">
      <ng-template let-smartEnergyData>
        <div class="chart-wrapper">
          <app-analytics-chart
            #smartEnergyChart
            [analyticsResults]="transformSmartEnergyData(smartEnergyData)"
            [resultsLabelsKey]="'ts'"
            [resultsValueKey]="'value'"
            [datasetLabels]="['kWh+', 'kWh-']"
            chartType="line"
            [colors]="['#00ABB0', '#E74C3C']"
            [showLegend]="false"
          ></app-analytics-chart>
        </div>
      </ng-template>
    </app-analytics-widget>
  </app-analytics-card>
</div>
